// @flow
import React, { useEffect } from "react";
import { Form, Message } from "semantic-ui-react";
import { type FieldProps } from "redux-form";

type InputTextProps = {|
  label: string,
  id: string,
  type: string,
  placeholder: string,
  autofocus: boolean,
  autocomplete: string,
  onError?: Function,
|} & FieldProps;

function InputText(props: InputTextProps) {
  const { label, id, type, placeholder, autofocus, autocomplete, meta, onError } = props;

  useEffect(() => {
    if (meta.touched && meta.error && onError) {
      onError(meta.error);
    }
  }, [meta.touched, meta.error, onError]);

  return (
    <>
      <Form.Input
        type={type}
        label={label}
        placeholder={placeholder}
        autoFocus={autofocus}
        autoComplete={autocomplete}
        id={id}
        {...props.input}
      />
      {props.meta.touched && props.meta.error && <Message negative>{props.meta.error}</Message>}
    </>
  );
}

export default InputText;
